import { useState } from 'react';

function Marquee(props) {
  const sepoliaBalance =  parseFloat(props.Ethbalance);
    
  const bscBalance  = parseFloat(props.bscBalance);

  const erc20TokenBalance = parseFloat(props.dioBalance)
  const ethUsd = props.EthUsd;
  const bnbUsd  =props.BnbUsd;
  const Sepoliausd = sepoliaBalance*ethUsd;
  const bscUsd = bscBalance*bnbUsd;
  
  const totalBalance  =  Sepoliausd + bscUsd ;
  const USDBALANCE = parseFloat(totalBalance).toFixed(2);
  

  const [data, setData] = useState([
    'This is the first message ',
    'This is the second message ',
    'This is the third message',
    'This is the fourth message',
    'This is the fourth message',
    
    
   
  ]);
  const [position, setPosition] = useState(0);

  // Update the position every 1 second
  setInterval(() => {
    setPosition((position + 2) % data.length);
  }, 3000);

  return (
    <div class="relative flex overflow-x-hidden bg-gray-200 max-h-fit ">
  <div class="py-12 animate-marquee whitespace-nowrap ">
    <span class="mx-4 text-4xl">ETHEREUM {sepoliaBalance}</span>
    <span class="mx-4 text-4xl">BNB {bscBalance}</span>
    <span class="mx-4 text-4xl">DIO {erc20TokenBalance}</span>
    <span class="mx-4 text-4xl">TOTAL BALANCE {USDBALANCE}</span>
    
  </div>

  <div class="absolute top-0 py-12 animate-marquee2 whitespace-nowrap">
    <span class="mx-4 text-4xl">ETHEREUM {bscBalance}</span>
    <span class="mx-4 text-4xl">BNB {bscBalance}</span>
    <span class="mx-4 text-4xl">DIO {erc20TokenBalance}</span>
    <span class="mx-4 text-4xl">TOTAL BALANCE {USDBALANCE}</span>
    
  </div>
</div>
  );
}

export default Marquee;
